/**
 * @generated SignedSource<<13a85af8e05b9a80d79ca6724754cd2f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EntityWithPositionInput = {
  id: string;
  position?: number | null;
};
export type CateringOptionsListSortMutation$variables = {
  positions: ReadonlyArray<EntityWithPositionInput>;
};
export type CateringOptionsListSortMutation$data = {
  readonly updateCateringOptionPositions: boolean;
};
export type CateringOptionsListSortMutation = {
  response: CateringOptionsListSortMutation$data;
  variables: CateringOptionsListSortMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "positions"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "positions",
        "variableName": "positions"
      }
    ],
    "kind": "ScalarField",
    "name": "updateCateringOptionPositions",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CateringOptionsListSortMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CateringOptionsListSortMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b42b29405604939c4d675ea4c86309c3",
    "id": null,
    "metadata": {},
    "name": "CateringOptionsListSortMutation",
    "operationKind": "mutation",
    "text": "mutation CateringOptionsListSortMutation(\n  $positions: [EntityWithPositionInput!]!\n) {\n  updateCateringOptionPositions(positions: $positions)\n}\n"
  }
};
})();

(node as any).hash = "e4bbc377c21618e57a9841c07b427830";

export default node;
